import { AccountService } from 'api';
import { GetLastNews } from 'models/api';

export const getPrimaryMarketItemLastNews = async (data: GetLastNews) => {
	return await AccountService.getLastNewsOfProject(data);
};
